import React from 'react'

// styles
import { ContactUsStylesStylesContainer } from './styles/ContactUsStyles'

// icons
import { FaAddressCard, FaPhoneAlt } from 'react-icons/fa'
import { MdEmail } from 'react-icons/md'

// includes
import Breadcrumbs from './Includes/Breadcrumbs'

export default function ContactUs(props) {
    // props
    const {
        currentRoute
    } = props

    return (
        <ContactUsStylesStylesContainer>
            <div className="container">
                <Breadcrumbs currentRoute={currentRoute} />

                <div className="content row">
                    {/* left sec */}
                    <div className="lt-sec col-12 col-lg-5 mb-3">
                        {/* address details */}
                        <div className="address-details mb-3 mb-lg-4">
                            {/* item */}
                            <div className="item d-flex align-items-center st-fs-17 mb-3">
                                <div className="head">
                                    <p className="mb-0 d-flex align-items-center">
                                        <FaAddressCard />
                                        <span className="ms-2 st-fw-600">Address:</span>
                                    </p>
                                </div>
                                <div className="text media-body ps-2">
                                    <p className="mb-0">Atlanta Georgia</p>
                                </div>
                            </div>

                            {/* item */}
                            <div className="item d-flex align-items-center st-fs-17 mb-3">
                                <div className="head">
                                    <p className="mb-0 d-flex align-items-center">
                                        <MdEmail fontSize={16} />
                                        <span className="ms-2 st-fw-600">Email:</span>
                                    </p>
                                </div>
                                <div className="text media-body ps-2">
                                    <p className="mb-0">info@ruhlistic.com</p>
                                </div>
                            </div>

                            {/* item */}
                            <div className="item d-flex align-items-center st-fs-17 mb-3">
                                <div className="head">
                                    <p className="mb-0 d-flex align-items-center">
                                        <FaPhoneAlt fontSize={14} />
                                        <span className="ms-2 st-fw-600">Phone:</span>
                                    </p>
                                </div>
                                <div className="text media-body ps-2">
                                    {/* <p className="mb-0">+1 (678) 237-3520</p> */}
                                    <p className="mb-0">+1 (802) 551-1313</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* right sec */}
                    <div className="lt-sec col-12 col-lg-7 mb-3">
                        <div className="map">
                            <iframe
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d212270.74113421215!2d-84.5606895386273!3d33.76763377186056!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88f5045d6993098d%3A0x66fede2f990b630b!2sAtlanta%2C%20GA%2C%20USA!5e0!3m2!1sen!2sin!4v1636711030962!5m2!1sen!2sin"
                                title="map"
                                width="100%"
                                height="450"
                                style={{ border: 0 }}
                                allowfullscreen=""
                                loading="lazy"></iframe>
                        </div>
                    </div>
                </div>
            </div>
        </ContactUsStylesStylesContainer>
    )
}
